<template>
  <div>
    <Header></Header>

    <HeaderBanner></HeaderBanner>

    <Services></Services>

    <ChooseUs></ChooseUs>

    <AboutUs></AboutUs>

    <HowItWorks></HowItWorks>

    <ContactUs></ContactUs>

    <Footer></Footer>
  </div>
</template>

<script>
const Header = () =>
  import(/* webpackChunkName: "header" */ "./../components/Header");

const Footer = () =>
  import(/* webpackChunkName: "header" */ "./../components/Footer");

const Services = () =>
  import(/* webpackChunkName: "services"  */ "./../components/Services");

const HeaderBanner = () =>
  import(/* webpackChunkName: "HeaderBanner" */ "./../components/HeaderBanner");

const ChooseUs = () =>
  import(/* webpackChunkName: "ChooseUs" */ "./../components/ChooseUs");

const AboutUs = () =>
  import(/* webpackChunkName: "AboutUs" */ "./../components/AboutUs");

const HowItWorks = () =>
  import(/* webpackChunkName: "HowItWorks" */ "./../components/HowItWorks");

const ContactUs = () =>
  import(/* webpackChunkName: "ContactUs" */ "./../components/ContactUs");

export default {
  namespaced: true,
  components: {
    Header,
    Footer,
    Services,
    HeaderBanner,
    ChooseUs,
    AboutUs,
    HowItWorks,
    ContactUs
  }
};
</script>
